module.exports = __webpack_public_path__ + "img/Popup_Hotspot.7a7be033.png";